import { render, staticRenderFns } from "./IcoPersonArrowLeftRight.vue?vue&type=template&id=581ee032"
import script from "./IcoPersonArrowLeftRight.vue?vue&type=script&lang=js"
export * from "./IcoPersonArrowLeftRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports